import axios from "axios";
import { DATABASE_URL } from "../../constants";

// In dev the Vite proxy rewrites /solar_calculator → devapi.arka360.com, so
// we use an empty baseURL (relative) to avoid CORS when the WebView connects
// from a local-network IP.  In production use the full DATABASE_URL directly.
const _heatAxios = axios.create({
    baseURL: import.meta.env.DEV ? '' : DATABASE_URL,
});

// Mirror the global SET_AXIOS_RESPONSE_HANDLER unwrapping for this custom instance.
// The global interceptor only applies to the default axios instance; custom instances
// must register their own interceptors.
_heatAxios.interceptors.response.use(
    (response) => {
        const d = response.data;
        if (d && typeof d === 'object' && 'success' in d && d.data !== undefined) {
            response.data = d.data;
        }
        return response;
    },
    (error) => { throw error; }
);

export default {
    FETCH_HEAT_SOLAR(postData) {
        return _heatAxios.post('/solar_calculator/solar_irradiance/', postData);
    }
}